/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = NotTested
 *
 * 1 = Ok
 *
 * 2 = Warning
 *
 * 3 = NotOk
 */
export enum CheckBoxStatus {
  NotTested = 0,
  Ok = 1,
  Warning = 2,
  NotOk = 3,
}
